<template>
  <div>
    <ValidationProvider
      :name="$t('labels.company')"
      :rules="'required'"
      v-slot="{ errors }"
    >
      <v-select
        :items="companyTypes"
        :disabled="disabled"
        :label="$t('labels.company')"
        :error-messages="errors[0]"
        :value="value"
        :multiple="multiple"
        @change="onChange"
        :item-text="itemText || 'Name'"
        :item-value="itemValue || 'Id'"
      ></v-select>
    </ValidationProvider>
  </div>
</template>

<script>
import GroupService from "../services/GroupService";

export default {
  name: "CompanySelect",
  methods: {
    onChange(inputValue) {
      this.$emit("input", inputValue || []);
    },

    getCompanyTypes() {
      this.$store.state.loadingStatus = true;

      GroupService.getCompanyTypes()
        .then((response) => {
          const data = response.data;
          if (data?.length > 0) {
            this.companyTypes = data;
          }
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },
  },
  mounted() {
    this.getCompanyTypes();
  },
  data: () => {
    return {
      companyTypes: [],
    };
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },

    itemText: {
      type: [String],
      default: null,
    },

    itemValue: {
      type: [String],
      default: null,
    },

    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
